import { render, staticRenderFns } from "./PriceWorkflowSidebar.vue?vue&type=template&id=2472fa66&scoped=true&"
import script from "./PriceWorkflowSidebar.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowSidebar.vue?vue&type=style&index=0&id=2472fa66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472fa66",
  null
  
)

export default component.exports